
// Average time it takes a human user to solve a ticket manually in minutes
export const averageTicketTime: number = 10

// Average Time used on tickets per week per user in minutes d*h*m
export const averageWeektime: number = 5 * 8 * 60